


























import { Component, Prop, Inject, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import HasValidation from "@/mixins/HasValidation";
import BrandsStore from "@/mixins/brandsStore";

// Types
import {
  ICategoryProviderData,
  ICategoryProviderMethods
} from "@/models/providers/categories";
import { IProductCategory } from "@/models/products";
import { IProductCategoryProvisioningForm } from "@/models/provisioning";

@Component({
  components: {
    "provision-defer-mode-field": () =>
      import(
        "@/components/app/admin/catalogue/categories/provisionDeferModeField.vue"
      )
  }
})
export default class EditCategory extends Mixins(HasValidation, BrandsStore) {
  // Inject - Category provider data

  @Inject({ from: "categoryProviderData" })
  public readonly $categoryProviderData!: () => ICategoryProviderData;

  public get $categoryData() {
    return this.$categoryProviderData();
  }

  // Inject - Category provider methods

  @Inject({ from: "categoryProviderMethods" })
  public readonly $categoryMethods!: ICategoryProviderMethods;

  // Props

  @Prop({ required: true })
  public categoryId!: IProductCategory["id"];

  // Data

  public isProcessing = false;

  public form = {} as IProductCategoryProvisioningForm;
  public initialForm = {} as IProductCategoryProvisioningForm;

  // Life-cycle methods

  public created() {
    this.initializeForm();
  }

  // Methods

  public initializeForm() {
    this.form = _.pick(this.$categoryData.category, [
      "provision_setup_field_defer_mode"
    ]) as IProductCategoryProvisioningForm;
    this.initialForm = _.cloneDeep(this.form);
  }

  public async validateBeforeSubmit() {
    try {
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");

      this.isProcessing = true;

      await this.$categoryMethods.updateCategory(this.newFormValues);
      await this.$categoryMethods.reloadData();

      this.initializeForm();

      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.category_successfully_updated")
      });
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public revertToInitialState() {
    this.form = _.cloneDeep(this.initialForm);
  }

  // Computed

  public get newFormValues() {
    return _.omitBy(this.form, (v, k) => {
      return this.initialForm[k] === v;
    });
  }

  public get isFormChanged(): boolean {
    return !_.isEqual(this.form, this.initialForm);
  }

  public get formIsDisabled() {
    return (
      !this.$categoryData.canUpdate ||
      this.$categoryData.isStaged ||
      this.isProcessing ||
      this.hasErrors
    );
  }
}
